const redirectURL = 'https://shopify.pxf.io/B0jzzW'

document.addEventListener('DOMContentLoaded', () => {
    initBlogPagination();
});

function initBlogPagination() {
    const POSTS_PER_PAGE = 10;

    const elements = {
        container: document.getElementById('js-all-posts'),
        blogLists: document.getElementById('js-blog-lists'),
        pagination: document.getElementById('js-pagination'),
        overlay: document.querySelector('.js-loading-overlay'),
    };

    let articles = getArticlesData();
    let currentPage = getCurrentPage();

    renderPosts();

    function getArticlesData() {
        const data = JSON.parse(document.getElementById('all-articles-json').textContent);
        return Array.isArray(data) ? data : [];
    }

    function getCurrentPage() {
        const page = parseInt(new URLSearchParams(window.location.search).get('page'));
        return !isNaN(page) && page > 0 ? page : 1;
    }

    function getArticleHtml(article, index) {
        const showExcerpt = index === 0;
        const postDate = formatDate(article.published_at);

        return `
            <div class="blog-item ${showExcerpt ? 'blog-first mb-6 first:col-span-2' : ''} post flex flex-col gap-5 overflow-hidden">
                <div class="media-thumb rounded-xl relative overflow-hidden border border-[#333333]">
                    ${article.image?.src ? `
                        <a href="${article.url}/">
                            <picture class="eb-image-picture block overflow-hidden aspect-[2/1] rounded-xl">
                                <img
                                    srcset="${generateSrcSet(article.image)}"
                                    sizes="(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw"
                                    src="${article.image.src}?width=750"
                                    alt="${article.image.alt || article.title}"
                                    loading="lazy"
                                    class="object-cover h-full w-full"
                                />
                            </picture>
                        </a>` : ''}
                </div>

                <div class="article-content flex flex-col gap-1.5">
                    <a href="/blogs/${article.blog_handle}"
                        class="tags text-[14px] text-[#999999] uppercase tracking-[10%] font-500 table">
                        ${article.blog_handle}
                    </a>

                    <a href="${article.url}/" class="table">
                        <h3 class="article-title capitalize font-semibold text-xl line-clamp-2">
                            ${article.title}
                        </h3>
                    </a>

                    <div class="flex flex-wrap items-center justify-between">
                        <p class="article-date text-sm text-gray-500">${postDate}</p>

                        ${showExcerpt ? (`
                            <a href="${article.url}" class="hidden md:flex font-semibold items-center gap-1 text-[14px] text-[#F05A5A] leading-5">
                                <span> Read More </span> 
                                <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10" fill="none">
                                    <path d="M0.625 8.625L4.625 4.625L0.625 0.625" stroke="#F05A5A" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/> 
                                </svg>
                            </a> `) : ''}
                    </div>
                </div>
                
                ${showExcerpt ? (`
                    <div class="be-wave">
                        <div class="-!right-[20vw] !top-[5vw] be-wave__blob be-wave__blob--1"></div>
                        <div class="-!right-[20vw] !top-[5vw] be-wave__blob be-wave__blob--2"></div>
                        <div class="-!right-[20vw] !top-[5vw] be-wave__blob be-wave__blob--3"></div>
                    </div>`) : ''}
            </div>
        `;
    }

    function changePage(page) {
        currentPage = page;
        updateUrl(page);
        renderPosts();
        scrollToList();
    }

    function scrollToList() {
        const top = elements.container.getBoundingClientRect().top + window.scrollY - 200;
        window.scrollTo({ top, behavior: 'smooth' });
    }

    function renderPosts() {
        const start = (currentPage - 1) * POSTS_PER_PAGE;
        const posts = articles.slice(start, start + POSTS_PER_PAGE);

        setTimeout(() => {

            const items = [];

            const shouldInsertBanner = currentPage === 1;

            posts.forEach((article, index) => {

                // Banner sau bài số 6
                if (shouldInsertBanner && index === 6) {
                    items.push({ __type: 'banner' });
                }

                items.push({
                    __type: 'post',
                    data: article,
                    index
                });
            });

            // nếu posts < 7 thì banner nằm cuối
            if (shouldInsertBanner && posts.length <= 6) {
                items.push({ __type: 'banner' });
            }

            elements.blogLists.innerHTML = items.map(item => {

                if (item.__type === 'banner') {
                    return `
                        <div class="blog-banner blog-item overflow-hidden post flex flex-col gap-5 visible rounded-xl relative flex flex-col items-center justify-center text-center p-6 lg:p-12 min-h-[330px] lg:min-h-[450px]">
                            <div class="relative z-10">
                                <h3 class="text-2xl font-bold mb-2 capitalize">
                                    Start your online business with our Shopify themes.
                                </h3>
                                <p class="mb-4 text-bm">
                                    Free plan with full access available forever. No credit card required.
                                </p>
                                <a href="${redirectURL}"
                                    target="_blank"
                                    class="eb-button-primary py-1.5 px-4 lg:py-2.5 lg:px-6 mt-4">
                                    Start for free
                                </a>
                            </div>                            

                            <div class="be-wave transform !scale-[1]">
                                <div class="!right-[-45vw] be-wave__blob be-wave__blob--1"></div>
                                <div class="!right-[-45vw] be-wave__blob be-wave__blob--2"></div>
                                <div class="!right-[-45vw] be-wave__blob be-wave__blob--3"></div>
                            </div>
                        </div>
                    `;
                }

                const { data: article, index } = item;
                return getArticleHtml(article, index);
            }).join('');


            const postElements = elements.blogLists.querySelectorAll('.post');
            postElements.forEach((post, i) => {
                setTimeout(() => {
                    post.classList.add('visible');
                }, i * 150);
            });

            elements.overlay.remove();

            renderPagination();

        }, 500);
    }

    function renderPagination() {
        const totalPages = Math.ceil(articles.length / POSTS_PER_PAGE);
        const { pagination } = elements;

        pagination.innerHTML = '';
        pagination.style.display = totalPages <= 1 ? 'none' : 'flex';

        if (totalPages <= 1) return;

        if (currentPage > 1) pagination.appendChild(createButton('Previous', currentPage - 1));

        pagination.appendChild(createButton(1, 1, currentPage === 1));

        if (currentPage > 3) pagination.appendChild(createDots());

        for (
            let i = Math.max(2, currentPage - 1);
            i <= Math.min(totalPages - 1, currentPage + 1);
            i++
        ) {
            pagination.appendChild(createButton(i, i, currentPage === i));
        }

        if (currentPage < totalPages - 2) pagination.appendChild(createDots());

        if (totalPages > 1) {
            pagination.appendChild(createButton(totalPages, totalPages, currentPage === totalPages));
        }

        if (currentPage < totalPages) {
            pagination.appendChild(createButton('Next', currentPage + 1));
        }
    }

    // helpers
    function createButton(label, page, active = false) {
        const btn = document.createElement('button');
        btn.textContent = label;
        btn.className = ` ${label == 'Previous' || label == 'Next' ? 'btn-text' : ''} 
                          ${active ? 'active' : ''}`;
        btn.addEventListener('click', () => changePage(page));
        return btn;
    }

    function createDots() {
        const dots = document.createElement('span');
        dots.textContent = '...';
        dots.className = 'px-2';
        return dots;
    }

    function updateUrl(page) {
        const url = new URL(window.location.href);
        page === 1 ? url.searchParams.delete('page') : url.searchParams.set('page', page);
        window.history.pushState({}, '', url);
    }

    function formatDate(arr) {
        if (!Array.isArray(arr) || arr.length < 6) return '';

        const [sec, min, hour, day, month, year] = arr;

        return new Date(year, month - 1, day, hour, min, sec).toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
        });
    }

    function stripHtml(html = '') {
        return html.replace(/<\/?[^>]+(>|$)/g, '');
    }

    function generateSrcSet(image) {
        const widths = [165, 330, 535, 750, 1000, 1500, 3000];

        return widths
            .filter(width => image.width >= width)
            .map(width => `${image.src}?width=${width} ${width}w`)
            .concat(`${image.src} ${image.width}w`)
            .join(', ');
    }
}